import { SAR_STATUS_LABEL_MAP, SARStatus } from 'dashboard/models/sar';
import Sticker, { StickerProps } from 'design-system/components/Sticker';

const SAR_STATUS_VARIANT_MAP: Record<SARStatus, StickerProps['variant']> = {
  [SARStatus.Open]: 'basic',
  [SARStatus.Pending]: 'caution',
  [SARStatus.Filed]: 'caution',
  [SARStatus.FiledManually]: 'success',
  [SARStatus.FiledElectronically]: 'caution',
  [SARStatus.Accepted]: 'caution',
  [SARStatus.AcceptedWithWarnings]: 'caution',
  [SARStatus.Processed]: 'success',
  [SARStatus.ProcessedWithWarnings]: 'success',
  [SARStatus.Rejected]: 'danger',
  [SARStatus.Archived]: 'basic',
};

interface SARStatusStickerProps {
  status: SARStatus;
}

const SARStatusSticker = ({ status }: SARStatusStickerProps) => (
  <Sticker variant={SAR_STATUS_VARIANT_MAP[status]}>{SAR_STATUS_LABEL_MAP[status]}</Sticker>
);

export default SARStatusSticker;
